// ============================================================================
// apiConfig.js  —  SINGLE SOURCE OF TRUTH for the backend the app talks to.
//
// To switch the WHOLE app (dev proxy AND production build; host + protocol)
// between servers, change ONE line: `ACTIVE_SERVER` below.
//   ACTIVE_SERVER = 'local'      -> localIP          (local testing)
//   ACTIVE_SERVER = 'staging'    -> stagingServerIP   (staging / cloud)
//   ACTIVE_SERVER = 'production' -> finalServerIP     (production)
//
// Environment variables still WIN when set (used by Docker / CI):
//   REACT_APP_API_HOST, REACT_APP_API_PROTO
//
// CommonJS (module.exports) on purpose: this file is consumed BOTH by the
// webpack app (import) AND by setupProxy.js (require), so dev and prod can
// never disagree about which server they point at.
// ============================================================================

function normalizeHost(value) {
  if (!value) return value;
  // strip any protocol prefix and any trailing path so only host[:port] remains
  return value.replace(/^https?:\/\//i, '').replace(/\/.*$/, '');
}

// --- The three backends. Hosts are BARE: no protocol, no trailing path, no
//     "/UI". Every endpoint method in UrlHelperClass adds "/UI/frontend/..."
//     itself, so these MUST NOT include it (else URLs get a double "/UI"). ---
const stagingServerIP = { proto: 'https', host: 'juniors.omniqpon.in' };                      // staging / cloud (https = port 443)
const finalServerIP   = { proto: 'https', host: 'omniqpon.in' };                              // production
const localIP         = { proto: 'https', host: 'harness-unhelpful-postage.ngrok-free.dev' }; // local testing

// --- The single switch: 'local' | 'staging' | 'production' ---
const ACTIVE_SERVER = 'production';  // change this to switch the whole app between servers

const SERVERS = {
  local: localIP,
  staging: stagingServerIP,
  production: finalServerIP,
};

const selected = SERVERS[ACTIVE_SERVER] || localIP;

const envHost  = process.env.REACT_APP_API_HOST;
const envProto = process.env.REACT_APP_API_PROTO;

const proto = (envProto === 'http' || envProto === 'https') ? envProto : selected.proto;
const host  = envHost ? normalizeHost(envHost) : selected.host;

// --- Promo-image server (StarCloudPRNT createpass) — a DIFFERENT service on a
//     different host/port than the API. Switch it here too; never hardcode it
//     inline in a page. ---
const promoImage = {
  proto: 'https',
  host: 'omniqpon.co.in:14013',
  path: '/starcloudprnt/createpass/promoimage/',
};

module.exports = {
  proto,
  host,
  origin: `${proto}://${host}`,
  promoImageOrigin: `${promoImage.proto}://${promoImage.host}${promoImage.path}`,
};
